import React from 'react';
import { asyncComponent } from '@jaredpalmer/after';

export default [
  {
    path: '/',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/magazine',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // require
    }),
  },
  {
    path: '/magazine/:id',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/tag',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/tag/:tag',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/author',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/author/:author',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/search',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/search/:queryText',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/:category',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/:category/:id',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/careers',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
  {
    path: '/careers/:id',
    exact: true,
    component: asyncComponent({
      loader: () => import('./components/App'), // required
    }),
  },
];